import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import React from 'react';
import gql from 'graphql-tag';
import PinInput from 'react-pin-input';
import { Form, Message, Modal, Header } from 'semantic-ui-react';
import { AuthClient, handleFocusStolen, EventSystem, getProfileAvatar } from '@emyw/core-lib';
import { isOpera, isChrome, isBlink } from '../utils';
import ButtonLink from '../ButtonLink';
import '../primitives.css';
const validateProfilePinMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation ($profileId: Int!, $pin: String!) {\n        validatePin: validateProfilePin (profileId: $profileId, pin: $pin) {\n            ok\n            errors {\n                path\n                message\n            }\n        }\n    }\n"])));
const validatePinMutation = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    mutation ($userId: Int!, $pin: String!) {\n        validatePin (userId: $userId, pin: $pin) {\n            ok\n            errors {\n                path\n                message\n            }\n        }\n    }\n"])));
class EnterPinForm extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      isSubmitting: false
      // pin: null,
    };
    // handlePinInputChange = (value) => {
    //     this.safeSetState({ pin: value });
    // }
    this.handleVerifyPin = value => {
      const {
        onSuccessClose,
        user,
        profile
      } = this.props;
      // if we see that they have entered the right number of values, attempt to validate the pin
      if ((value || '').length > 3) {
        // call the server to validate pin
        this.safeSetState({
          isSubmitting: true,
          pin: value
        });
        // console.log('setting profile', user, profile);
        let mutate;
        if (profile) {
          mutate = {
            mutation: validateProfilePinMutation,
            variables: {
              profileId: profile.id,
              pin: value
            }
          };
        } else {
          mutate = {
            mutation: validatePinMutation,
            variables: {
              userId: user.id,
              pin: value
            }
          };
        }
        AuthClient.mutate(mutate).then(res => {
          log.trace(res);
          const {
            ok,
            errors
          } = res.data.validatePin;
          if (ok) {
            onSuccessClose();
            this.safeSetState({
              isSubmitting: false,
              errors: null,
              pin: null
            });
          } else {
            this.safeSetState({
              isSubmitting: false,
              errors: errors.map(err => err.message),
              pin: null
            });
          }
        }).catch(error => {
          log.warn('error handling pin:', error.message);
          this.safeSetState({
            isSubmitting: false,
            errors: [error.message],
            pin: null
          });
        });
      }
    };
    this.handleForgotPinClose = () => {
      const {
        onForgotPinClose
      } = this.props;
      onForgotPinClose();
    };
    this.handleFailClose = () => {
      const {
        onFailClose
      } = this.props;
      onFailClose();
    };
    this.safeSetState = (state, cb) => {
      if (this.mounted) {
        this.setState(state, cb);
      }
    };
    /* Prevent autofill */
    this.handlePinRef = ref => {
      if (!ref) return;
      this.pinInputRef = ref;
      (ref.elements || []).forEach(element => {
        if (!(element || {}).input) return;
        element.input.setAttribute('autocomplete', 'new-password');
        element.input.setAttribute('data-lpignore', 'true');
        // log.trace('input:', element.input);

        /* eslint-disable-next-line no-param-reassign */
        if (element && element.input) element.input.onblur = handleFocusStolen;
        // if (element && element.input) element.input.addEventListener('blur', handleFocusStolen);
      });
    };
    this.removePinEventListeners = () => {
      ((this.pinInputRef || {}).elements || []).forEach(element => {
        /* eslint-disable-next-line no-param-reassign */
        if (element && element.input) element.input.onblur = null;
        // if (element && element.input) element.input.removeEventListener('blur', handleFocusStolen);
      });
    };
  }
  componentDidMount() {
    this.mounted = true;
    // use this to stop chrome from prompting to save these as passwords
    // If not chrome, then we'll just set the type to password (i.e. secret = true). If it is chrome, we'll use the
    // textSecurity: 'disc' trick for a input type='text', which doesn't work in other browsers.
    this.useSecret = !(isChrome || isOpera || isBlink);
  }
  componentDidUpdate(prevProps) {
    const {
      profile,
      modalMode,
      showEnterPinModal
    } = this.props;
    if (this.state.errors && (modalMode && !showEnterPinModal || (prevProps.profile || {}).id !== (profile || {}).id)) {
      log.trace('component updated. prevProps:', prevProps, 'this.props:', this.props);
      this.safeSetState({
        errors: null
      });
    }
  }
  componentWillUnmount() {
    this.mounted = false;
    this.removePinEventListeners();
  }
  render() {
    const {
      profile,
      modalMode,
      showEnterPinModal,
      prompt,
      mountNode,
      dimmer
    } = this.props;
    const {
      isSubmitting,
      pin,
      errors
    } = this.state;

    // log.trace('profile:', profile);

    // log.trace('prompt', prompt);
    const ErrorMessage = () => (errors || []).length > 0 ? /*#__PURE__*/React.createElement(Message, {
      size: "small",
      error: true
      // header={<Message.Header>We don&apos;t recognize the PIN you entered.<br />Please try again.</Message.Header>}
      ,
      header: /*#__PURE__*/React.createElement(Message.Header, null, "Incorrect ", profile ? 'profile' : 'account', " PIN.", /*#__PURE__*/React.createElement("br", null), "Please try again.")
      // header={"We don't recognize the PIN you entered. Please try again."}
      // list={errors}
    }) : null;
    const Content = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PinInput, {
      ref: this.handlePinRef,
      initialValue: pin || '',
      length: 4,
      type: "text",
      secret: this.useSecret,
      focus: !isSubmitting,
      style: {
        padding: ''
      } // Required to allow css file to set
      /* Empty border and margin required to allow css file to set: */,
      inputStyle: {
        opacity: isSubmitting ? 0.5 : 1,
        textSecurity: 'disc',
        WebkitTextSecurity: 'disc',
        border: '',
        margin: ''
      },
      inputFocusStyle: {
        border: ''
      } // Required to allow css file to set
      // onChange={this.handlePinInputChange}
      ,
      onComplete: this.handleVerifyPin
    }), /*#__PURE__*/React.createElement(ErrorMessage, null), /*#__PURE__*/React.createElement("br", null), isSubmitting ? /*#__PURE__*/React.createElement("div", null, "Validating...") : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ButtonLink, {
      color: "blue",
      onClick: this.handleForgotPinClose
    }, "Forgot PIN?"), /*#__PURE__*/React.createElement("span", {
      style: {
        padding: '1em'
      }
    }), /*#__PURE__*/React.createElement(ButtonLink, {
      color: "blue",
      onClick: this.handleFailClose
    }, "Cancel")));
    if (modalMode) {
      return /*#__PURE__*/React.createElement(Modal, {
        className: "enjoyModal enterPinModal",
        open: showEnterPinModal,
        onMount: () => {
          if (mountNode && mountNode.id !== 'EnjoyApp') EventSystem.publish('enjoyDialogClose');
        },
        size: "mini",
        mountNode: mountNode || undefined,
        dimmer: dimmer
      }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement(Header, null, prompt && !prompt.header && prompt, prompt && prompt.header, prompt && prompt.subheader && /*#__PURE__*/React.createElement(Header.Subheader, null, prompt.subheader), !prompt && profile && 'Please enter your PIN for', !prompt && !profile && 'Please enter your account PIN'), !prompt && profile && /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '0.6em 1.8em 0 1.8em',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "avatar_wrapper"
      }, getProfileAvatar({
        profile,
        className: 'menu',
        avatarFloat: 'left',
        iconSize: 'large'
      })), /*#__PURE__*/React.createElement("div", {
        className: "profile_avatar_name menuCol",
        style: {
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      }, /*#__PURE__*/React.createElement("strong", null, profile.name)))), /*#__PURE__*/React.createElement(Modal.Content, {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement(Content, null)));
    }
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form, {
      error: (errors || []).length > 0,
      style: {
        position: 'absolute',
        top: '40%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        transform: 'translate(0, -50%)'
      }
    }, prompt && /*#__PURE__*/React.createElement("h2", null, prompt), /*#__PURE__*/React.createElement("h3", null, profile ? /*#__PURE__*/React.createElement("div", null, "Please enter your PIN for") : /*#__PURE__*/React.createElement("div", null, "Please enter your account PIN")), profile && /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center',
        maxWidth: '100%'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "avatar_wrapper",
      style: {
        margin: '0 0 0.2em 0'
      }
    }, getProfileAvatar({
      profile,
      className: 'menu',
      avatarFloat: 'left',
      iconSize: 'large'
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "profile_avatar_name menuCol",
      style: {
        padding: '0 0.6em',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }, /*#__PURE__*/React.createElement("strong", null, profile.name))), /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement(Content, null))));
  }
}
EnterPinForm.defaultProps = {
  profile: null,
  dimmer: true,
  modalMode: false,
  prompt: null,
  mountNode: undefined
};
export default EnterPinForm;